import type { AppProps } from 'next/app'
import { Auth0Provider } from '@auth0/auth0-react'
import Layout from '../components/Layout'
import Script from 'next/script'

const App = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      <Script
        src="https://browser.sentry-cdn.com/6.17.2/bundle.min.js"
        integrity="sha384-WkFzsrcXKeJ3KlWNXojDiim8rplIj1RPsCbuv7dsLECoXY8C6Cx158CMgl+O+QKW"
        crossOrigin="anonymous"
      />

      <Auth0Provider
        domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN as string}
        clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID as string}
        redirectUri={
          (typeof window !== 'undefined' && window.location.origin) || ''
        }
        useRefreshTokens={true}
        audience={process.env.NEXT_PUBLIC_AUTH0_AUDIENCE as string}
      >
        {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          Layout(<Component {...pageProps} />, pageProps)
        }
      </Auth0Provider>
    </>
  )
}

export default App
